module.exports = __webpack_public_path__ + "img/122-Rapa Nui.38fce8c6.svg";